import { Link } from 'react-router-dom';

export default function AboutHero() {
  return (
    <section className="relative pt-20 min-h-[420px] md:min-h-[480px] flex items-end overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20biotech%20pharmaceutical%20factory%20interior%20with%20clean%20production%20line%20equipment%20stainless%20steel%20tanks%20workers%20in%20white%20uniforms%2C%20bright%20professional%20industrial%20environment%2C%20health%20supplement%20manufacturing%20facility&width=1920&height=480&seq=about-hero-bg-01&orientation=landscape"
          alt="關於康永背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a1a]/85 via-[#1a3a1a]/60 to-[#1a3a1a]/30" />
      </div>

      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-16 pt-24">
        <div className="max-w-2xl">
          <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 tracking-wide">
            不只是代工廠
          </span>
          <h1 className="text-white font-bold leading-tight mb-5">
            <span className="block">更是您信賴的生技</span>
            <span className="block text-green-300">創新研發夥伴</span>
          </h1>
          <p className="text-gray-200 text-[1.0625rem] leading-[1.75] max-w-xl mb-8">
            康永生技以專業研發實力與嚴格品管制度，協助品牌從概念到上市，成為保健食品代工領域最值得信賴的長期夥伴。
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/contact/form"
              className="whitespace-nowrap bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
            >
              立即諮詢
            </Link>
            <Link
              to="/services"
              className="whitespace-nowrap bg-white/15 hover:bg-white/25 border border-white/60 text-white font-semibold text-[1rem] px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
            >
              查看服務
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
